export const useEtablissementId = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    const etablissementId = user?.etablissement[0]?.id

    return { etablissementId }
}